import { meta as _about_AboutCompany } from "../src/pages/about/AboutCompany.pagemeta";
import { meta as _about_CookiePolicy } from "../src/pages/about/CookiePolicy.pagemeta";
import { meta as _about_PrivacyPolicy } from "../src/pages/about/PrivacyPolicy.pagemeta";
import { meta as _about_TermsOfUse } from "../src/pages/about/TermsOfUse.pagemeta";
import { meta as _admin_agency_AgencyDetails } from "../src/pages/admin/agency/AgencyDetails.pagemeta";
import { meta as _admin_agency_WarehouseCalendar } from "../src/pages/admin/agency/WarehouseCalendar.pagemeta";
import { meta as _admin_agency_index_pagemeta } from "../src/pages/admin/agency/index.pagemeta";
import { meta as _admin_booking_AllBookings } from "../src/pages/admin/booking/AllBookings.pagemeta";
import { meta as _admin_booking_BookingCreate } from "../src/pages/admin/booking/BookingCreate.pagemeta";
import { meta as _admin_booking_BookingCreateComplete } from "../src/pages/admin/booking/BookingCreateComplete.pagemeta";
import { meta as _admin_booking_BookingDetails } from "../src/pages/admin/booking/BookingDetails.pagemeta";
import { meta as _admin_booking_BookingInquiries } from "../src/pages/admin/booking/BookingInquiries.pagemeta";
import { meta as _admin_booking_CanceledBookings } from "../src/pages/admin/booking/CanceledBookings.pagemeta";
import { meta as _admin_booking_CurrentBookingsAfterDeparture } from "../src/pages/admin/booking/CurrentBookingsAfterDeparture.pagemeta";
import { meta as _admin_booking_CurrentBookingsBeforeDeparture } from "../src/pages/admin/booking/CurrentBookingsBeforeDeparture.pagemeta";
import { meta as _admin_booking_CustomsCommodityExport } from "../src/pages/admin/booking/CustomsCommodityExport.pagemeta";
import { meta as _admin_booking_CustomsInstruction } from "../src/pages/admin/booking/CustomsInstruction.pagemeta";
import { meta as _admin_booking_CustomsRequestDetails } from "../src/pages/admin/booking/CustomsRequestDetails.pagemeta";
import { meta as _admin_booking_Dashboard } from "../src/pages/admin/booking/Dashboard.pagemeta";
import { meta as _admin_booking_DeliveryInstruction } from "../src/pages/admin/booking/DeliveryInstruction.pagemeta";
import { meta as _admin_booking_DeliveryRequestDetails } from "../src/pages/admin/booking/DeliveryRequestDetails.pagemeta";
import { meta as _admin_booking_DeliveryRequests } from "../src/pages/admin/booking/DeliveryRequests.pagemeta";
import { meta as _admin_booking_ExportPreAlert } from "../src/pages/admin/booking/ExportPreAlert.pagemeta";
import { meta as _admin_booking_ExportSeaWaybill } from "../src/pages/admin/booking/ExportSeaWaybill.pagemeta";
import { meta as _admin_booking_InquiryDetails } from "../src/pages/admin/booking/InquiryDetails.pagemeta";
import { meta as _admin_booking_InvoiceDetail } from "../src/pages/admin/booking/InvoiceDetail.pagemeta";
import { meta as _admin_booking_PastBookings } from "../src/pages/admin/booking/PastBookings.pagemeta";
import { meta as _admin_booking_PaymentSlipDetails } from "../src/pages/admin/booking/PaymentSlipDetails.pagemeta";
import { meta as _admin_booking_PrintBarcode } from "../src/pages/admin/booking/PrintBarcode.pagemeta";
import { meta as _admin_booking_PrintCustomsRequestLog } from "../src/pages/admin/booking/PrintCustomsRequestLog.pagemeta";
import { meta as _admin_booking_PrintDeliveryRequestLog } from "../src/pages/admin/booking/PrintDeliveryRequestLog.pagemeta";
import { meta as _admin_booking_PrintInvoiceLog } from "../src/pages/admin/booking/PrintInvoiceLog.pagemeta";
import { meta as _admin_booking_PrintPaymentSlipLog } from "../src/pages/admin/booking/PrintPaymentSlipLog.pagemeta";
import { meta as _admin_booking_PrintPreAlertLog } from "../src/pages/admin/booking/PrintPreAlertLog.pagemeta";
import { meta as _admin_booking_PrintSeaWaybillLog } from "../src/pages/admin/booking/PrintSeaWaybillLog.pagemeta";
import { meta as _admin_booking_index_pagemeta } from "../src/pages/admin/booking/index.pagemeta";
import { meta as _admin_invoice_InvoiceList } from "../src/pages/admin/invoice/InvoiceList.pagemeta";
import { meta as _admin_invoice_PaymentSlipBatchDetails } from "../src/pages/admin/invoice/PaymentSlipBatchDetails.pagemeta";
import { meta as _admin_invoice_PaymentSlipBatchList } from "../src/pages/admin/invoice/PaymentSlipBatchList.pagemeta";
import { meta as _admin_invoice_PaymentSlipList } from "../src/pages/admin/invoice/PaymentSlipList.pagemeta";
import { meta as _admin_invoice_index_pagemeta } from "../src/pages/admin/invoice/index.pagemeta";
import { meta as _admin_members_CompletionRequests } from "../src/pages/admin/members/CompletionRequests.pagemeta";
import { meta as _admin_members_MemberDetails } from "../src/pages/admin/members/MemberDetails.pagemeta";
import { meta as _admin_members_Members } from "../src/pages/admin/members/Members.pagemeta";
import { meta as _admin_members_MembershipFormDetails } from "../src/pages/admin/members/MembershipFormDetails.pagemeta";
import { meta as _admin_members_MembershipForms } from "../src/pages/admin/members/MembershipForms.pagemeta";
import { meta as _admin_members_Users } from "../src/pages/admin/members/Users.pagemeta";
import { meta as _admin_members_index_pagemeta } from "../src/pages/admin/members/index.pagemeta";
import { meta as _admin_staffs_AddStaff } from "../src/pages/admin/staffs/AddStaff.pagemeta";
import { meta as _admin_staffs_Password } from "../src/pages/admin/staffs/Password.pagemeta";
import { meta as _admin_staffs_Profile } from "../src/pages/admin/staffs/Profile.pagemeta";
import { meta as _admin_staffs_Staff } from "../src/pages/admin/staffs/Staff.pagemeta";
import { meta as _admin_staffs_Staffs } from "../src/pages/admin/staffs/Staffs.pagemeta";
import { meta as _admin_staffs_index_pagemeta } from "../src/pages/admin/staffs/index.pagemeta";
import { meta as _admin_widgets_Agencies } from "../src/pages/admin/widgets/Agencies.pagemeta";
import { meta as _admin_widgets_AgencyDetails } from "../src/pages/admin/widgets/AgencyDetails.pagemeta";
import { meta as _admin_widgets_CargoTracking } from "../src/pages/admin/widgets/CargoTracking.pagemeta";
import { meta as _admin_widgets_CargoTrackingDetails } from "../src/pages/admin/widgets/CargoTrackingDetails.pagemeta";
import { meta as _admin_widgets_ExchangeCalendar } from "../src/pages/admin/widgets/ExchangeCalendar.pagemeta";
import { meta as _admin_widgets_PartnerDetails } from "../src/pages/admin/widgets/PartnerDetails.pagemeta";
import { meta as _admin_widgets_Partners } from "../src/pages/admin/widgets/Partners.pagemeta";
import { meta as _admin_widgets_RoutePlanDetail } from "../src/pages/admin/widgets/RoutePlanDetail.pagemeta";
import { meta as _admin_widgets_RoutePlanManagement } from "../src/pages/admin/widgets/RoutePlanManagement.pagemeta";
import { meta as _admin_widgets_VesselSchedule } from "../src/pages/admin/widgets/VesselSchedule.pagemeta";
import { meta as _admin_widgets_WarehouseCalendar } from "../src/pages/admin/widgets/WarehouseCalendar.pagemeta";
import { meta as _admin_widgets_index_pagemeta } from "../src/pages/admin/widgets/index.pagemeta";
import { meta as _settings_AccountManager_Profile } from "../src/pages/settings/AccountManager/Profile.pagemeta";
import { meta as _settings_AccountManager_Security } from "../src/pages/settings/AccountManager/Security.pagemeta";
import { meta as _settings_Membership_Checklist } from "../src/pages/settings/Membership/Checklist.pagemeta";
import { meta as _settings_Membership_CompanyInfo } from "../src/pages/settings/Membership/CompanyInfo.pagemeta";
import { meta as _settings_Membership_DelegationForm } from "../src/pages/settings/Membership/DelegationForm.pagemeta";
import { meta as _settings_Membership_PrincipalInfo } from "../src/pages/settings/Membership/PrincipalInfo.pagemeta";
import { meta as _utilities_BlanketInsurance_BlanketInsurances } from "../src/pages/utilities/BlanketInsurance/BlanketInsurances.pagemeta";
import { meta as _utilities_BookingInquiry_Complete } from "../src/pages/utilities/BookingInquiry/Complete.pagemeta";
import { meta as _utilities_BookingInquiry_InquiryForm } from "../src/pages/utilities/BookingInquiry/InquiryForm.pagemeta";
import { meta as _utilities_BookingInquiry_MobileCautions } from "../src/pages/utilities/BookingInquiry/MobileCautions.pagemeta";
import { meta as _utilities_Bookings_BookingInquiryHistory } from "../src/pages/utilities/Bookings/BookingInquiryHistory.pagemeta";
import { meta as _utilities_Bookings_BookingInquiryHistoryDetails } from "../src/pages/utilities/Bookings/BookingInquiryHistoryDetails.pagemeta";
import { meta as _utilities_Bookings_CurrentBookingDetails } from "../src/pages/utilities/Bookings/CurrentBookingDetails.pagemeta";
import { meta as _utilities_Bookings_CurrentBookings } from "../src/pages/utilities/Bookings/CurrentBookings.pagemeta";
import { meta as _utilities_Bookings_CustomsInstructionList } from "../src/pages/utilities/Bookings/CustomsInstructionList.pagemeta";
import { meta as _utilities_Bookings_DeliveryInstructionList } from "../src/pages/utilities/Bookings/DeliveryInstructionList.pagemeta";
import { meta as _utilities_Bookings_PastBookingDetails } from "../src/pages/utilities/Bookings/PastBookingDetails.pagemeta";
import { meta as _utilities_Bookings_PastBookings } from "../src/pages/utilities/Bookings/PastBookings.pagemeta";
import { meta as _utilities_CargoTracking_CargoTracking } from "../src/pages/utilities/CargoTracking/CargoTracking.pagemeta";
import { meta as _utilities_Commodity_Commodities } from "../src/pages/utilities/Commodity/Commodities.pagemeta";
import { meta as _utilities_Contact_Consignees_Consignees } from "../src/pages/utilities/Contact/Consignees/Consignees.pagemeta";
import { meta as _utilities_Contact_Shippers_Shippers } from "../src/pages/utilities/Contact/Shippers/Shippers.pagemeta";
import { meta as _utilities_Dashboard } from "../src/pages/utilities/Dashboard.pagemeta";
import { meta as _utilities_Invoice_InvoiceList } from "../src/pages/utilities/Invoice/InvoiceList.pagemeta";
import { meta as _utilities_PriceSimulator_PriceSimulator } from "../src/pages/utilities/PriceSimulator/PriceSimulator.pagemeta";
export const meta = [
  {
    url: "/Loading",
    name: "Loading",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/Maintenance",
    name: "Maintenance",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/NoMatch",
    name: "NoMatch",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/NotAuthorized",
    name: "NotAuthorized",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/about/AboutCompany",
    name: "AboutCompany",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._about_AboutCompany,
  },

  {
    url: "/about/CookiePolicy",
    name: "CookiePolicy",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._about_CookiePolicy,
  },

  {
    url: "/about/PrivacyPolicy",
    name: "PrivacyPolicy",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._about_PrivacyPolicy,
  },

  {
    url: "/about/TermsOfUse",
    name: "TermsOfUse",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._about_TermsOfUse,
  },

  {
    url: "/admin/agency/AgencyDetails",
    name: "AgencyDetails",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_agency_AgencyDetails,
  },

  {
    url: "/admin/agency/WarehouseCalendar",
    name: "WarehouseCalendar",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_agency_WarehouseCalendar,
  },

  {
    url: "/admin/agency",
    name: "",
    isDirectory: true,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_agency_index_pagemeta,
  },

  {
    url: "/admin/auth/ForgetPassword",
    name: "ForgetPassword",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/admin/auth/Login",
    name: "Login",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/admin/auth/ResetPassword",
    name: "ResetPassword",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/admin/booking/AllBookings",
    name: "AllBookings",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_AllBookings,
  },

  {
    url: "/admin/booking/BookingCreate",
    name: "BookingCreate",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_BookingCreate,
  },

  {
    url: "/admin/booking/BookingCreateComplete",
    name: "BookingCreateComplete",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_BookingCreateComplete,
  },

  {
    url: "/admin/booking/BookingDetails",
    name: "BookingDetails",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_BookingDetails,
  },

  {
    url: "/admin/booking/BookingInquiries",
    name: "BookingInquiries",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_BookingInquiries,
  },

  {
    url: "/admin/booking/CanceledBookings",
    name: "CanceledBookings",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_CanceledBookings,
  },

  {
    url: "/admin/booking/CurrentBookingsAfterDeparture",
    name: "CurrentBookingsAfterDeparture",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_CurrentBookingsAfterDeparture,
  },

  {
    url: "/admin/booking/CurrentBookingsBeforeDeparture",
    name: "CurrentBookingsBeforeDeparture",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_CurrentBookingsBeforeDeparture,
  },

  {
    url: "/admin/booking/CustomsCommodityExport",
    name: "CustomsCommodityExport",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_CustomsCommodityExport,
  },

  {
    url: "/admin/booking/CustomsInstruction",
    name: "CustomsInstruction",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_CustomsInstruction,
  },

  {
    url: "/admin/booking/CustomsRequestDetails",
    name: "CustomsRequestDetails",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_CustomsRequestDetails,
  },

  {
    url: "/admin/booking/Dashboard",
    name: "Dashboard",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_Dashboard,
  },

  {
    url: "/admin/booking/DeliveryInstruction",
    name: "DeliveryInstruction",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_DeliveryInstruction,
  },

  {
    url: "/admin/booking/DeliveryRequestDetails",
    name: "DeliveryRequestDetails",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_DeliveryRequestDetails,
  },

  {
    url: "/admin/booking/DeliveryRequests",
    name: "DeliveryRequests",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_DeliveryRequests,
  },

  {
    url: "/admin/booking/ExportPreAlert",
    name: "ExportPreAlert",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_ExportPreAlert,
  },

  {
    url: "/admin/booking/ExportSeaWaybill",
    name: "ExportSeaWaybill",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_ExportSeaWaybill,
  },

  {
    url: "/admin/booking/InquiryDetails",
    name: "InquiryDetails",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_InquiryDetails,
  },

  {
    url: "/admin/booking/InvoiceDetail",
    name: "InvoiceDetail",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_InvoiceDetail,
  },

  {
    url: "/admin/booking/PastBookings",
    name: "PastBookings",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_PastBookings,
  },

  {
    url: "/admin/booking/PaymentSlipDetails",
    name: "PaymentSlipDetails",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_PaymentSlipDetails,
  },

  {
    url: "/admin/booking/PrintBarcode",
    name: "PrintBarcode",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_PrintBarcode,
  },

  {
    url: "/admin/booking/PrintCustomsRequestLog",
    name: "PrintCustomsRequestLog",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_PrintCustomsRequestLog,
  },

  {
    url: "/admin/booking/PrintDeliveryRequestLog",
    name: "PrintDeliveryRequestLog",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_PrintDeliveryRequestLog,
  },

  {
    url: "/admin/booking/PrintInvoiceLog",
    name: "PrintInvoiceLog",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_PrintInvoiceLog,
  },

  {
    url: "/admin/booking/PrintPaymentSlipLog",
    name: "PrintPaymentSlipLog",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_PrintPaymentSlipLog,
  },

  {
    url: "/admin/booking/PrintPreAlertLog",
    name: "PrintPreAlertLog",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_PrintPreAlertLog,
  },

  {
    url: "/admin/booking/PrintSeaWaybillLog",
    name: "PrintSeaWaybillLog",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_PrintSeaWaybillLog,
  },

  {
    url: "/admin/booking",
    name: "",
    isDirectory: true,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_booking_index_pagemeta,
  },

  {
    url: "/admin/invoice/InvoiceList",
    name: "InvoiceList",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_invoice_InvoiceList,
  },

  {
    url: "/admin/invoice/PaymentSlipBatchDetails",
    name: "PaymentSlipBatchDetails",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_invoice_PaymentSlipBatchDetails,
  },

  {
    url: "/admin/invoice/PaymentSlipBatchList",
    name: "PaymentSlipBatchList",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_invoice_PaymentSlipBatchList,
  },

  {
    url: "/admin/invoice/PaymentSlipList",
    name: "PaymentSlipList",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_invoice_PaymentSlipList,
  },

  {
    url: "/admin/invoice",
    name: "",
    isDirectory: true,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_invoice_index_pagemeta,
  },

  {
    url: "/admin/members/CompletionRequests",
    name: "CompletionRequests",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_members_CompletionRequests,
  },

  {
    url: "/admin/members/MemberDetails",
    name: "MemberDetails",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_members_MemberDetails,
  },

  {
    url: "/admin/members/Members",
    name: "Members",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_members_Members,
  },

  {
    url: "/admin/members/MembershipFormDetails",
    name: "MembershipFormDetails",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_members_MembershipFormDetails,
  },

  {
    url: "/admin/members/MembershipForms",
    name: "MembershipForms",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_members_MembershipForms,
  },

  {
    url: "/admin/members/Users",
    name: "Users",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_members_Users,
  },

  {
    url: "/admin/members",
    name: "",
    isDirectory: true,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_members_index_pagemeta,
  },

  {
    url: "/admin/staffs/AddStaff",
    name: "AddStaff",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_staffs_AddStaff,
  },

  {
    url: "/admin/staffs/Password",
    name: "Password",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_staffs_Password,
  },

  {
    url: "/admin/staffs/Profile",
    name: "Profile",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_staffs_Profile,
  },

  {
    url: "/admin/staffs/Staff",
    name: "Staff",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_staffs_Staff,
  },

  {
    url: "/admin/staffs/Staffs",
    name: "Staffs",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_staffs_Staffs,
  },

  {
    url: "/admin/staffs",
    name: "",
    isDirectory: true,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_staffs_index_pagemeta,
  },

  {
    url: "/admin/widgets/Agencies",
    name: "Agencies",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_widgets_Agencies,
  },

  {
    url: "/admin/widgets/AgencyDetails",
    name: "AgencyDetails",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_widgets_AgencyDetails,
  },

  {
    url: "/admin/widgets/CargoTracking",
    name: "CargoTracking",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_widgets_CargoTracking,
  },

  {
    url: "/admin/widgets/CargoTrackingDetails",
    name: "CargoTrackingDetails",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_widgets_CargoTrackingDetails,
  },

  {
    url: "/admin/widgets/ExchangeCalendar",
    name: "ExchangeCalendar",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_widgets_ExchangeCalendar,
  },

  {
    url: "/admin/widgets/PartnerDetails",
    name: "PartnerDetails",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_widgets_PartnerDetails,
  },

  {
    url: "/admin/widgets/Partners",
    name: "Partners",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_widgets_Partners,
  },

  {
    url: "/admin/widgets/RoutePlanDetail",
    name: "RoutePlanDetail",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_widgets_RoutePlanDetail,
  },

  {
    url: "/admin/widgets/RoutePlanManagement",
    name: "RoutePlanManagement",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_widgets_RoutePlanManagement,
  },

  {
    url: "/admin/widgets/VesselSchedule",
    name: "VesselSchedule",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_widgets_VesselSchedule,
  },

  {
    url: "/admin/widgets/WarehouseCalendar",
    name: "WarehouseCalendar",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_widgets_WarehouseCalendar,
  },

  {
    url: "/admin/widgets",
    name: "",
    isDirectory: true,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._admin_widgets_index_pagemeta,
  },

  {
    url: "/auth/ConfirmEmail",
    name: "ConfirmEmail",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/auth/CreateAccount",
    name: "CreateAccount",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/auth/CreateAccountVerifyEmail",
    name: "CreateAccountVerifyEmail",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/auth/ForgetPassword",
    name: "ForgetPassword",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/auth/Login",
    name: "Login",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/auth/ResendEmail",
    name: "ResendEmail",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/auth/ResetPassword",
    name: "ResetPassword",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/dev/About",
    name: "About",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/dev/Accounts",
    name: "Accounts",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/dev/E2eMail",
    name: "E2eMail",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/dev/FCProxy",
    name: "FCProxy",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/dev/Impersonate",
    name: "Impersonate",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/dev/MockKikan",
    name: "MockKikan",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/dev/NextForm",
    name: "NextForm",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/dev/Svgs",
    name: "Svgs",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/dev/Theme",
    name: "Theme",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/dev/Urls",
    name: "Urls",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/dev/tests/TestBadResponse",
    name: "TestBadResponse",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/dev/tests/TestError",
    name: "TestError",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/dev/tests/TestNextBadResponse",
    name: "TestNextBadResponse",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/dev/tests/TestPost400",
    name: "TestPost400",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/dev/tests/TestQingdaoRouteAlert",
    name: "TestQingdaoRouteAlert",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/dev/tests/TestStatusError404",
    name: "TestStatusError404",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/dev/tests/TestStatusError500",
    name: "TestStatusError500",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/dev/tests/TestTextBox",
    name: "TestTextBox",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/dev/tests/TestTypeError",
    name: "TestTypeError",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/external/CustomsRequestDownloadPdf",
    name: "CustomsRequestDownloadPdf",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/external/DeliveryRequestDownloadPdf",
    name: "DeliveryRequestDownloadPdf",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/external/DeliveryRequestReceiptUpload",
    name: "DeliveryRequestReceiptUpload",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/external/PrintCustomsRequestLog",
    name: "PrintCustomsRequestLog",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/external/PrintDeliveryRequestLog",
    name: "PrintDeliveryRequestLog",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/settings/AccountManager/Profile",
    name: "Profile",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._settings_AccountManager_Profile,
  },

  {
    url: "/settings/AccountManager/Security",
    name: "Security",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._settings_AccountManager_Security,
  },

  {
    url: "/settings/Membership/Checklist",
    name: "Checklist",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._settings_Membership_Checklist,
  },

  {
    url: "/settings/Membership/CompanyInfo",
    name: "CompanyInfo",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._settings_Membership_CompanyInfo,
  },

  {
    url: "/settings/Membership/DelegationForm",
    name: "DelegationForm",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._settings_Membership_DelegationForm,
  },

  {
    url: "/settings/Membership/PrincipalInfo",
    name: "PrincipalInfo",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._settings_Membership_PrincipalInfo,
  },

  {
    url: "/utilities/BlanketInsurance/AddBlanketInsurance",
    name: "AddBlanketInsurance",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/BlanketInsurance/BlanketInsuranceDetails",
    name: "BlanketInsuranceDetails",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/BlanketInsurance/BlanketInsurances",
    name: "BlanketInsurances",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._utilities_BlanketInsurance_BlanketInsurances,
  },

  {
    url: "/utilities/BookingInquiry/Complete",
    name: "Complete",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._utilities_BookingInquiry_Complete,
  },

  {
    url: "/utilities/BookingInquiry/InquiryForm",
    name: "InquiryForm",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._utilities_BookingInquiry_InquiryForm,
  },

  {
    url: "/utilities/BookingInquiry/MobileCautions",
    name: "MobileCautions",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._utilities_BookingInquiry_MobileCautions,
  },

  {
    url: "/utilities/Bookings/BookingInquiryHistory",
    name: "BookingInquiryHistory",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._utilities_Bookings_BookingInquiryHistory,
  },

  {
    url: "/utilities/Bookings/BookingInquiryHistoryDetails",
    name: "BookingInquiryHistoryDetails",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._utilities_Bookings_BookingInquiryHistoryDetails,
  },

  {
    url: "/utilities/Bookings/BookingInquiryLogs",
    name: "BookingInquiryLogs",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Bookings/CurrentBookingDetails",
    name: "CurrentBookingDetails",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._utilities_Bookings_CurrentBookingDetails,
  },

  {
    url: "/utilities/Bookings/CurrentBookings",
    name: "CurrentBookings",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._utilities_Bookings_CurrentBookings,
  },

  {
    url: "/utilities/Bookings/CustomsInstruction",
    name: "CustomsInstruction",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Bookings/CustomsInstructionList",
    name: "CustomsInstructionList",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._utilities_Bookings_CustomsInstructionList,
  },

  {
    url: "/utilities/Bookings/DeliveryGuidance",
    name: "DeliveryGuidance",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Bookings/DeliveryInstruction",
    name: "DeliveryInstruction",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Bookings/DeliveryInstructionList",
    name: "DeliveryInstructionList",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._utilities_Bookings_DeliveryInstructionList,
  },

  {
    url: "/utilities/Bookings/ExportArrivalNotice",
    name: "ExportArrivalNotice",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Bookings/ExportPreAlert",
    name: "ExportPreAlert",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Bookings/ExportSeaWaybill",
    name: "ExportSeaWaybill",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Bookings/PastBookingDetails",
    name: "PastBookingDetails",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._utilities_Bookings_PastBookingDetails,
  },

  {
    url: "/utilities/Bookings/PastBookings",
    name: "PastBookings",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._utilities_Bookings_PastBookings,
  },

  {
    url: "/utilities/Bookings/PrintArrivalNoticeLogs",
    name: "PrintArrivalNoticeLogs",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Bookings/PrintBarcode",
    name: "PrintBarcode",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Bookings/PrintCurrentBookingDetails",
    name: "PrintCurrentBookingDetails",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Bookings/PrintPreAlertLog",
    name: "PrintPreAlertLog",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Bookings/PrintSeaWaybillLog",
    name: "PrintSeaWaybillLog",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/CargoTracking/CargoTracking",
    name: "CargoTracking",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._utilities_CargoTracking_CargoTracking,
  },

  {
    url: "/utilities/CargoTracking/CargoTrackingResult",
    name: "CargoTrackingResult",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/CargoTracking/PrintCargoTrackingDetails",
    name: "PrintCargoTrackingDetails",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/CargoTracking/PrintCargoTrackingOverview",
    name: "PrintCargoTrackingOverview",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Commodity/AddCommodity",
    name: "AddCommodity",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Commodity/Commodities",
    name: "Commodities",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._utilities_Commodity_Commodities,
  },

  {
    url: "/utilities/Commodity/CommodityDetails",
    name: "CommodityDetails",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Contact/Consignees/AddConsignee",
    name: "AddConsignee",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Contact/Consignees/ConsigneeDetails",
    name: "ConsigneeDetails",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Contact/Consignees/Consignees",
    name: "Consignees",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._utilities_Contact_Consignees_Consignees,
  },

  {
    url: "/utilities/Contact/Shippers/AddShipper",
    name: "AddShipper",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Contact/Shippers/ShipperDetails",
    name: "ShipperDetails",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Contact/Shippers/Shippers",
    name: "Shippers",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._utilities_Contact_Shippers_Shippers,
  },

  {
    url: "/utilities/Dashboard",
    name: "Dashboard",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._utilities_Dashboard,
  },

  {
    url: "/utilities/Friend/InvitationsReceived",
    name: "InvitationsReceived",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Friend/InvitationsSent",
    name: "InvitationsSent",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Invoice/InvoiceList",
    name: "InvoiceList",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._utilities_Invoice_InvoiceList,
  },

  {
    url: "/utilities/MembershipForm/Checklist",
    name: "Checklist",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/MembershipForm/Complete",
    name: "Complete",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/MembershipForm/DelegationForm",
    name: "DelegationForm",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/MembershipForm/Information",
    name: "Information",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/MembershipForm/PolicyAgreement",
    name: "PolicyAgreement",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/NotificationCenter/NotificationCenter",
    name: "NotificationCenter",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Notifications/ChineseNewYear2023",
    name: "ChineseNewYear2023",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Notifications/GoldenWeek2023",
    name: "GoldenWeek2023",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Notifications/NewYear2023",
    name: "NewYear2023",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/Notifications/PriceUp",
    name: "PriceUp",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
  },

  {
    url: "/utilities/PriceSimulator/PriceSimulator",
    name: "PriceSimulator",
    isDirectory: false,
    listed: true,
    staffOnly: false,
    superuserOnly: false,
    ..._utilities_PriceSimulator_PriceSimulator,
  },
];
export type AppUrl =
  | "/Loading"
  | "/Maintenance"
  | "/NoMatch"
  | "/NotAuthorized"
  | "/about/AboutCompany"
  | "/about/CookiePolicy"
  | "/about/PrivacyPolicy"
  | "/about/TermsOfUse"
  | "/admin/agency/AgencyDetails"
  | "/admin/agency/WarehouseCalendar"
  | "/admin/agency"
  | "/admin/auth/ForgetPassword"
  | "/admin/auth/Login"
  | "/admin/auth/ResetPassword"
  | "/admin/booking/AllBookings"
  | "/admin/booking/BookingCreate"
  | "/admin/booking/BookingCreateComplete"
  | "/admin/booking/BookingDetails"
  | "/admin/booking/BookingInquiries"
  | "/admin/booking/CanceledBookings"
  | "/admin/booking/CurrentBookingsAfterDeparture"
  | "/admin/booking/CurrentBookingsBeforeDeparture"
  | "/admin/booking/CustomsCommodityExport"
  | "/admin/booking/CustomsInstruction"
  | "/admin/booking/CustomsRequestDetails"
  | "/admin/booking/Dashboard"
  | "/admin/booking/DeliveryInstruction"
  | "/admin/booking/DeliveryRequestDetails"
  | "/admin/booking/DeliveryRequests"
  | "/admin/booking/ExportPreAlert"
  | "/admin/booking/ExportSeaWaybill"
  | "/admin/booking/InquiryDetails"
  | "/admin/booking/InvoiceDetail"
  | "/admin/booking/PastBookings"
  | "/admin/booking/PaymentSlipDetails"
  | "/admin/booking/PrintBarcode"
  | "/admin/booking/PrintCustomsRequestLog"
  | "/admin/booking/PrintDeliveryRequestLog"
  | "/admin/booking/PrintInvoiceLog"
  | "/admin/booking/PrintPaymentSlipLog"
  | "/admin/booking/PrintPreAlertLog"
  | "/admin/booking/PrintSeaWaybillLog"
  | "/admin/booking"
  | "/admin/invoice/InvoiceList"
  | "/admin/invoice/PaymentSlipBatchDetails"
  | "/admin/invoice/PaymentSlipBatchList"
  | "/admin/invoice/PaymentSlipList"
  | "/admin/invoice"
  | "/admin/members/CompletionRequests"
  | "/admin/members/MemberDetails"
  | "/admin/members/Members"
  | "/admin/members/MembershipFormDetails"
  | "/admin/members/MembershipForms"
  | "/admin/members/Users"
  | "/admin/members"
  | "/admin/staffs/AddStaff"
  | "/admin/staffs/Password"
  | "/admin/staffs/Profile"
  | "/admin/staffs/Staff"
  | "/admin/staffs/Staffs"
  | "/admin/staffs"
  | "/admin/widgets/Agencies"
  | "/admin/widgets/AgencyDetails"
  | "/admin/widgets/CargoTracking"
  | "/admin/widgets/CargoTrackingDetails"
  | "/admin/widgets/ExchangeCalendar"
  | "/admin/widgets/PartnerDetails"
  | "/admin/widgets/Partners"
  | "/admin/widgets/RoutePlanDetail"
  | "/admin/widgets/RoutePlanManagement"
  | "/admin/widgets/VesselSchedule"
  | "/admin/widgets/WarehouseCalendar"
  | "/admin/widgets"
  | "/auth/ConfirmEmail"
  | "/auth/CreateAccount"
  | "/auth/CreateAccountVerifyEmail"
  | "/auth/ForgetPassword"
  | "/auth/Login"
  | "/auth/ResendEmail"
  | "/auth/ResetPassword"
  | "/dev/About"
  | "/dev/Accounts"
  | "/dev/E2eMail"
  | "/dev/FCProxy"
  | "/dev/Impersonate"
  | "/dev/MockKikan"
  | "/dev/NextForm"
  | "/dev/Svgs"
  | "/dev/Theme"
  | "/dev/Urls"
  | "/dev/tests/TestBadResponse"
  | "/dev/tests/TestError"
  | "/dev/tests/TestNextBadResponse"
  | "/dev/tests/TestPost400"
  | "/dev/tests/TestQingdaoRouteAlert"
  | "/dev/tests/TestStatusError404"
  | "/dev/tests/TestStatusError500"
  | "/dev/tests/TestTextBox"
  | "/dev/tests/TestTypeError"
  | "/external/CustomsRequestDownloadPdf"
  | "/external/DeliveryRequestDownloadPdf"
  | "/external/DeliveryRequestReceiptUpload"
  | "/external/PrintCustomsRequestLog"
  | "/external/PrintDeliveryRequestLog"
  | "/settings/AccountManager/Profile"
  | "/settings/AccountManager/Security"
  | "/settings/Membership/Checklist"
  | "/settings/Membership/CompanyInfo"
  | "/settings/Membership/DelegationForm"
  | "/settings/Membership/PrincipalInfo"
  | "/utilities/BlanketInsurance/AddBlanketInsurance"
  | "/utilities/BlanketInsurance/BlanketInsuranceDetails"
  | "/utilities/BlanketInsurance/BlanketInsurances"
  | "/utilities/BookingInquiry/Complete"
  | "/utilities/BookingInquiry/InquiryForm"
  | "/utilities/BookingInquiry/MobileCautions"
  | "/utilities/Bookings/BookingInquiryHistory"
  | "/utilities/Bookings/BookingInquiryHistoryDetails"
  | "/utilities/Bookings/BookingInquiryLogs"
  | "/utilities/Bookings/CurrentBookingDetails"
  | "/utilities/Bookings/CurrentBookings"
  | "/utilities/Bookings/CustomsInstruction"
  | "/utilities/Bookings/CustomsInstructionList"
  | "/utilities/Bookings/DeliveryGuidance"
  | "/utilities/Bookings/DeliveryInstruction"
  | "/utilities/Bookings/DeliveryInstructionList"
  | "/utilities/Bookings/ExportArrivalNotice"
  | "/utilities/Bookings/ExportPreAlert"
  | "/utilities/Bookings/ExportSeaWaybill"
  | "/utilities/Bookings/PastBookingDetails"
  | "/utilities/Bookings/PastBookings"
  | "/utilities/Bookings/PrintArrivalNoticeLogs"
  | "/utilities/Bookings/PrintBarcode"
  | "/utilities/Bookings/PrintCurrentBookingDetails"
  | "/utilities/Bookings/PrintPreAlertLog"
  | "/utilities/Bookings/PrintSeaWaybillLog"
  | "/utilities/CargoTracking/CargoTracking"
  | "/utilities/CargoTracking/CargoTrackingResult"
  | "/utilities/CargoTracking/PrintCargoTrackingDetails"
  | "/utilities/CargoTracking/PrintCargoTrackingOverview"
  | "/utilities/Commodity/AddCommodity"
  | "/utilities/Commodity/Commodities"
  | "/utilities/Commodity/CommodityDetails"
  | "/utilities/Contact/Consignees/AddConsignee"
  | "/utilities/Contact/Consignees/ConsigneeDetails"
  | "/utilities/Contact/Consignees/Consignees"
  | "/utilities/Contact/Shippers/AddShipper"
  | "/utilities/Contact/Shippers/ShipperDetails"
  | "/utilities/Contact/Shippers/Shippers"
  | "/utilities/Dashboard"
  | "/utilities/Friend/InvitationsReceived"
  | "/utilities/Friend/InvitationsSent"
  | "/utilities/Invoice/InvoiceList"
  | "/utilities/MembershipForm/Checklist"
  | "/utilities/MembershipForm/Complete"
  | "/utilities/MembershipForm/DelegationForm"
  | "/utilities/MembershipForm/Information"
  | "/utilities/MembershipForm/PolicyAgreement"
  | "/utilities/NotificationCenter/NotificationCenter"
  | "/utilities/Notifications/ChineseNewYear2023"
  | "/utilities/Notifications/GoldenWeek2023"
  | "/utilities/Notifications/NewYear2023"
  | "/utilities/Notifications/PriceUp"
  | "/utilities/PriceSimulator/PriceSimulator";
export const url = (u: AppUrl) => u;
